export default {
    methods: {
        mixinCheckboxValue(type, item, hideHifen = true) {
            let value = ' ';
            let checked = false;
            let kmInterval = item.hasOwnProperty('kmInterval') ? item.kmInterval : '';
            let monthInterval = item.hasOwnProperty('monthInterval') ? item.monthInterval : '';
            let workPosDescription = item.hasOwnProperty('workPosDescription') ? item.workPosDescription : '';

            if(type == 'repair') {
                // workPosDescription = (item.workTime ? `${item.workTime} h` : item.workPosDescription) + ' - ' + (item.itemMpText ? item.itemMpText : '') + ' ' + (item.qualColText ? `[${item.qualColText}]` : '')
                workPosDescription = item.workPosDescription + (hideHifen ? '' : ' - ') + (item.itemMpText ? item.itemMpText : '') + ' ' + (item.qualColText ? `[${item.qualColText}]` : '')
                if(item.workTextTips4y) {
                  workPosDescription = item.workTextTips4y
                }
              }

            if (kmInterval !== '' || monthInterval !== '') {
                if (kmInterval !== '' && monthInterval !== '') {
                    value += `(${kmInterval} Km / ${monthInterval} M)`;
                } else if (kmInterval !== '') {
                    value += `(${kmInterval} Km)`;
                } else {
                    value += `(${monthInterval} M)`;
                }
            }

            let shoppingCart = this.$store.getters['budget/getB2bCurrentShoppingCart'];

            for (let i in shoppingCart.operations[type]) {
                if (shoppingCart.operations[type][i].workId == item.workId) {
                    checked = true;
                }
            }

            return {
                id: item.workId,
                value: workPosDescription + value,
                value2: type == 'repair' ? item.korText : '',
                checked: checked
            };
        }
    }
};
